import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { CREATE_TRUSTS_USER_MUTATION } from '../graphql/mutations/createTrustsUser';
import { GET_TRUSTS_USERS } from '../graphql/queries/getTrustsUsers';

export const useCreateTrustsUser = () => {
  const [createTrustsUserMutation, { data, loading, error }] = useMutation(CREATE_TRUSTS_USER_MUTATION, {
    refetchQueries: [{ query: GET_TRUSTS_USERS }]
  });

  const createTrustsUser = async (email: string) => {
    const variables = { trustsUserCreateDto: { email } };
    try {
      await createTrustsUserMutation({ variables });
      toast.success('Trusts user created successfully!');
      return { error: false };
    } catch (err) {
      toast.error(`There was an error creating the user: ${(err as Error).message}`);
      return { error: true };
    }
  };

  return { createTrustsUser, data, loading, error };
};
